@if (isPolicyViewEnabled && showPolicyView) {
  <app-policy-view-wrapper
    [policyView]="policyView"
    (eventTriggered)="onAction($event)"
    [theme]="theme"
  ></app-policy-view-wrapper>
} @else {
  <div class="main">
    @if (policy) {
      <div>
        <div class="row">
          <span class="heading-sub-page">{{ policy?.productDescription }}</span>
        </div>
        <div class="row">
          <umbrella-risk-card
            [underLyingPolicies]="{ underlyingPolicies }"
            [newAFIRiskCard]="true"
          ></umbrella-risk-card>
        </div>
        <div class="row pad-top-20 pad-bottom-20">
          <div class="image-container">
            <img src="/assets/images/Umbrella-foodle.png" />
          </div>
          <div class="view-coverge-details-wrapper">
            <button (click)="onCoverageDetailsClicked()">
              <div>View Coverage Details</div>
              <img src="/assets/images/doodle-arrow.svg" alt="View Coverage Details" />
            </button>
          </div>
        </div>
        <div class="simple-cards">
          <div class="left">
            <div class="margin-bottom-20">
              <ds-simple-card
                headerIcon="dollar-sign_doodle.svg"
                heading="Premium"
                [buttons]="premiumActionButtons"
                id="premiumCard"
              >
                <policy-discounts [policy]="policy"></policy-discounts>
              </ds-simple-card>
            </div>
          </div>
          <div class="right">
            <ds-simple-card
              headerIcon="coverage.svg"
              heading="Extra Coverages for My Policies"
              [buttons]="peopleCoveredActionButtons"
              id="coveragesCard"
            >
              <app-coverages [newAFITemplate]="true" [policy]="policy"></app-coverages>
            </ds-simple-card>
          </div>
        </div>
        @if (policyDocuments$ | async; as documents) {
          <div class="new-documents" id="documentsCard" isRendered (iAmReady)="scroll()">
            <policy-documents [documents]="documents"></policy-documents>
          </div>
        }
        <div class="policy-footer">
          <span
            *dsPartnerAFI
            dsContent
            [contentPath]="'policyDetail.detailFooterText'"
            [options]="{ name: 'agent' }"
          ></span>
          <span *dsPartnerAFI dsContent [contentPath]="'policyDetail.detailFooterTextAFI'"></span>
          <span
            *dsPartnerConnect
            dsContent
            [contentPath]="'policyDetail.detailFooterText'"
            [options]="{ name: 'representative' }"
          ></span>
          <span
            *dsPartnerConnect
            dsContent
            [contentPath]="'policyDetail.detailFooterTextPartner'"
          ></span>
        </div>
      </div>
    }
  </div>
}
